import Vue from 'vue'
import Vuex from 'vuex';
import { Toast } from 'mand-mobile'
import { getcwinfo, getsiteconfig, unreadcount } from '@/request/api'
const _ = require('lodash');


Vue.use(Vuex);
const store=new Vuex.Store({
  state: {
    userinfo: {},
    siteconfig: {},
    unread_count: -1,
    refresh_unreadcount_time: null
  },
  getters: {
    
  },
  mutations: {
    updateuserinfo(state, val) {
      state.userinfo = val;
    },
    updatesiteconfig(state, val) {
      state.siteconfig = _.merge(state.siteconfig, val);
    },
    updateunreadcount(state, val) {
      state.unread_count = val;
    },
    updaterefreshunreadcounttime(state, val) {
      state.refresh_unreadcount_time = val;
    }
  },
  actions: {
    asyncupdateuserinfo(store) {
      return new Promise((resolve, reject) => {
        getcwinfo({}).then((res)=>{
          if(res.code === 200) {
            store.commit('updateuserinfo', res.data);
            resolve(res.data);
          } else if (res.code === 403) {
            Toast.failed("login expired");
            localStorage.removeItem("token");
          }
        }).catch(error => {
          reject(error)
        })
      });
    },
    asyncupdatesiteconfig(store, key) {
      return new Promise((resolve, reject) => {
        getsiteconfig({k: key}).then((res)=>{
          if(res.code === 200) {
            store.commit('updatesiteconfig', res.data);
            resolve(res.data);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    asyncupdateunreadcount(store) {
      return new Promise((resolve, reject) => {
        if(store.state.refresh_unreadcount_time) {
          let now = new Date().getTime();
          let diff = now - store.state.refresh_unreadcount_time;
          if(diff < 6000) {
            resolve(store.state.unread_count);
            return;
          }
        }
        unreadcount().then((res)=>{
          store.commit('updateunreadcount', res.unread_count);
          store.commit('updaterefreshunreadcounttime', new Date().getTime());
          resolve(res.unread_count);
        }).catch(error => {
          reject(error)
        })
      });
    }
  },
  modules: {
    
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js